import type { BuildProject } from '../types'

/** Repair tasks for the Hardware Store "Repair" flow – reuses BuildProject shape (steps) */
export const REPAIR_TASKS: BuildProject[] = [
  {
    id: 'loose-screw',
    name: 'Tighten a Loose Screw',
    description: 'Fix something that’s wobbly',
    emoji: '🔩',
    steps: [
      { id: 'ls1', order: 1, label: 'Find the loose spot', instruction: 'Wiggle the thing gently. Where does it feel wobbly? That’s where the screw might be loose.', emoji: '👆', stage: 'gather' },
      { id: 'ls2', order: 2, label: 'Get the right screwdriver', instruction: 'Look at the screw head. Is it a line (flat) or a plus (+)? Get the matching screwdriver.', emoji: '🪛', stage: 'gather' },
      { id: 'ls3', order: 3, label: 'Turn it to the right', instruction: 'Put the screwdriver in the screw. Turn it clockwise (to the right) to tighten. Ask a grown-up to help if it’s stuck.', emoji: '↻', stage: 'assemble' },
      { id: 'ls4', order: 4, label: 'Check it', instruction: 'Wiggle again. Still wobbly? Give it another turn. When it’s tight, you’re done!', emoji: '✅', stage: 'done' },
    ],
  },
  {
    id: 'wobbly-chair',
    name: 'Fix a Wobbly Chair Leg',
    description: 'Make the chair steady again',
    emoji: '🪑',
    steps: [
      { id: 'wc1', order: 1, label: 'Turn the chair over', instruction: 'Ask a grown-up to flip the chair so the legs point up. Now you can see where the legs attach.', emoji: '🪑', stage: 'gather' },
      { id: 'wc2', order: 2, label: 'Find the loose part', instruction: 'Gently push each leg. Which one moves? That leg might need a screw or glue.', emoji: '🔍', stage: 'gather' },
      { id: 'wc3', order: 3, label: 'Tighten the screws', instruction: 'If you see screws where the leg meets the seat, use a screwdriver to tighten them. Turn to the right!', emoji: '🔩', stage: 'assemble' },
      { id: 'wc4', order: 4, label: 'Flip it back', instruction: 'A grown-up can flip the chair back. Sit on it carefully. Is it steady? You fixed it!', emoji: '🪑', stage: 'done' },
    ],
  },
  {
    id: 'hole-in-wall',
    name: 'Patch a Small Hole',
    description: 'Fill a little hole in the wall',
    emoji: '🧱',
    steps: [
      { id: 'hw1', order: 1, label: 'Get spackle and a putty knife', instruction: 'Spackle is like paste for walls. A grown-up can get it at the hardware store. You need a small putty knife too.', emoji: '🪣', stage: 'gather' },
      { id: 'hw2', order: 2, label: 'Push spackle into the hole', instruction: 'Use the putty knife to push a little spackle into the hole. Fill it so it’s flat with the wall.', emoji: '🧱', stage: 'assemble' },
      { id: 'hw3', order: 3, label: 'Let it dry', instruction: 'Spackle needs to dry. Wait as long as the package says – maybe a few hours or overnight.', emoji: '⏳', stage: 'finish' },
      { id: 'hw4', order: 4, label: 'Sand and paint', instruction: 'When it’s dry, a grown-up can sand it smooth and paint over it. The hole is gone!', emoji: '🎨', stage: 'done' },
    ],
  },
]
